import { connect } from 'react-redux'
import * as customerSelector from '../../state/detail/selector'
import * as action from '../../state/detail/action'
import AlignerCustomerCommunicationCommentWidget from './AlignerCustomerCommunicationCommentWidget'

const mapStateToProps = (state, props) => {
    return {
        customer: customerSelector.selectCustomer(state),
    }
}

const mapDispatchToProps = {
    saveTreatmentExecutionClarificationComment: action.saveTreatmentExecutionClarificationComment
}


export default connect(mapStateToProps, mapDispatchToProps)(AlignerCustomerCommunicationCommentWidget)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/AlignerCustomerCommunicationCommentWidgetContainer.js